/*
  Origin video
  Ported from Horizon's deferred-media component, without its framework.

  Before play, the player waits in a <template> behind a cover image button. Pressing it swaps the player in
  (which lets it start with sound on phones) and moves focus to it. Starting one video pauses any other
  Origin video that's playing, as in Horizon.

  Markup:
    <origin-video>
      <button data-origin-video-play>cover image and play icon</button>
      <template>video or iframe</template>
    </origin-video>
*/
if (!customElements.get('origin-video')) {
  const PLAY_EVENT = 'origin-video:play';

  class OriginVideo extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-origin-video-play]');
      this.onPlay = () => this.load();
      this.onOtherPlay = (event) => {
        if (event.detail !== this) this.pause();
      };

      this.button?.addEventListener('click', this.onPlay);
      document.addEventListener(PLAY_EVENT, this.onOtherPlay);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onPlay);
      document.removeEventListener(PLAY_EVENT, this.onOtherPlay);
    }

    load() {
      if (this.hasAttribute('data-media-loaded')) return;

      document.dispatchEvent(new CustomEvent(PLAY_EVENT, { detail: this }));

      const content = this.querySelector('template')?.content.firstElementChild?.cloneNode(true);
      if (!content) return;

      this.setAttribute('data-media-loaded', 'true');
      this.appendChild(content);
      content.focus();

      // Template-cloned videos don't reliably start from the autoplay attribute alone
      if (content instanceof HTMLVideoElement) content.play().catch(() => {});
    }

    pause() {
      const player = this.querySelector('.origin-video__player');
      if (!player) return;

      if (player instanceof HTMLVideoElement) {
        player.pause();
      } else if (player.src.includes('youtube')) {
        player.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      } else if (player.src.includes('vimeo')) {
        player.contentWindow?.postMessage('{"method":"pause"}', '*');
      }
    }
  }

  customElements.define('origin-video', OriginVideo);
}
